import { useTheme } from "@mui/material";
import { Track } from "../../../interfaces/dtos/track"
import { statusKeys, statusItems } from "../trackPage/trackPageHelper";
import { TrackListChangeStatusConfirmationItem } from "./TrackListChangeStatusConfirmationItem";

interface TrackListChangeStatusConfirmationProps {
    tracks: Track[];
    statusCode: string;
}

export const TrackListChangeStatusConfirmation = ({
    tracks, statusCode
}: TrackListChangeStatusConfirmationProps) => {

    const theme = useTheme();

    const statusItem = statusItems.find((si) => si.key === statusCode);
    const statusColour = statusCode === statusKeys.active ?
        theme.palette.success.main :
        theme.palette.warning.main;

    return (
        <>
            You are about to set the following track{tracks.length === 1 ? '' : 's'} to
            <span style={{ color: statusColour, fontWeight: 'bold' }}> {statusItem?.value}</span>.
            <br />
            Do you wish to proceed?
            <ul>
                {tracks.map((t) => (
                    <li key={t.key}>
                        <TrackListChangeStatusConfirmationItem track={t} />
                    </li>
                ))}
            </ul>
        </>
    )
}
